var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7153 14.8983C12.1696 18.6291 9.26105 11.369 2.71533 15.0999V5.09979C9.26105 1.3689 12.1696 8.629 18.7153 4.89812V14.8983Z",
    stroke: "#051B46",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7153 11.999C11.8199 11.999 12.7153 11.1036 12.7153 9.99902C12.7153 8.89445 11.8199 7.99902 10.7153 7.99902C9.61076 7.99902 8.71533 8.89445 8.71533 9.99902C8.71533 11.1036 9.61076 11.999 10.7153 11.999Z",
    stroke: "#051B46",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71533 7.99902V10.999",
    stroke: "#051B46",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7153 8.99902V11.999",
    stroke: "#051B46",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoin);
export default __webpack_public_path__ + "static/media/hand-coin.0b6a5d2b25601eafef5a60419dc34b2b.svg";
export { ForwardRef as ReactComponent };